import { Notification } from '../../models/interfaces/notification.interface';
import {
  NotificationsActions,
  SET_NOTIFICATIONS,
  ADD_NOTIFICATION,
  SET_NOTIFICATIONS_LIMIT,
  SET_NOTIFICATIONS_UNREAD,
  ADD_NOTIFICATIONS_UNREAD,
  REDUCE_NOTIFICATIONS_UNREAD,
  RESTART_NOTIFICATIONS_UNREAD,
  CLEAN_NOTIFICATIONS
} from './notifications.actions';

export interface State {
  notifications: Array<Notification>;
  notificationsLimit: number;
  unreadNotifications: number;
  infiniteScrollDisabled: boolean;
}

const initialState: State = {
  notifications: [],
  notificationsLimit: 0,
  unreadNotifications: 0,
  infiniteScrollDisabled: false
};

export function notificationsReducer(state = initialState, action: NotificationsActions) {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      const existingIds = new Set(state.notifications.map((notification) => notification.notificationId));
      const notifications = [...state.notifications];
      for (const notification of action.payload) {
        if (!existingIds.has(notification.notificationId)) {
          existingIds.add(notification.notificationId);
          notifications.push(notification);
        }
      }
      const newObject = {
        ...state,
        notifications
      };
      if (newObject.notifications.length >= state.notificationsLimit) {
        newObject.infiniteScrollDisabled = true;
      } else {
        newObject.infiniteScrollDisabled = false;
      }
      return newObject;
    case ADD_NOTIFICATION:
      const newNotification = action.payload as Notification;
      const notificationsExists = state.notifications.find((element) => element.notificationId === newNotification.notificationId);
      if (notificationsExists) {
        return {
          ...state
        };
      } else {
        return {
          ...state,
          notifications: [action.payload, ...state.notifications],
          unreadNotifications: state.unreadNotifications + 1
        };
      }
    case SET_NOTIFICATIONS_LIMIT:
      return {
        ...state,
        notificationsLimit: action.payload
      };
    case SET_NOTIFICATIONS_UNREAD:
      return {
        ...state,
        unreadNotifications: action.payload
      };
    case ADD_NOTIFICATIONS_UNREAD:
      return {
        ...state,
        unreadNotifications: state.unreadNotifications + 1
      };
    case REDUCE_NOTIFICATIONS_UNREAD:
      return {
        ...state,
        unreadNotifications: state.unreadNotifications - 1 >= 0 ? state.unreadNotifications - 1 : 0
      };
    case RESTART_NOTIFICATIONS_UNREAD:
      return {
        ...state,
        unreadNotifications: 0
      };
    case CLEAN_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        unreadNotifications: 0,
        notificationsLimit: 0,
        infiniteScrollDisabled: false
      };
    default: {
      return state;
    }
  }
}

export const getNotifications = (state: State) => state.notifications;
export const getNotificationsLimit = (state: State) => state.notificationsLimit;
export const getUnreadNotifications = (state: State) => state.unreadNotifications;
export const getInfiniteDisabled = (state: State) => state.infiniteScrollDisabled;
